import bootstrap from '~b/js/bootstrap.bundle.min.js'
window.bootstrap = bootstrap